<template>
  <div>
    <b-row v-if="plas == '4'">
      <b-col>
        <vs-card>
          <b-row align-v="center">
            <b-col cols="4">
              <v-select
                v-model="secilenKullanici"
                :options="optionsKullanicilar"
                @input="selectionChange"
                placeholder="Tezgahtar seçimi"
                label="name"
              ></v-select>
            </b-col>
            <b-col cols="2">
              <vs-button
                color="success"
                style="border-radius: 5px; margin: 10px"
                type="gradient"
                icon="edit"
                @click="kartDetayi()"
                >İşleme Al</vs-button
              >
            </b-col>
          </b-row>
        </vs-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row style="margin-bottom: 25px">
          <b-col>
            <vx-card>
              <b-row>
                <b-col cols="6">
                  <b-row align-h="start">
                    <b-col cols="12" md="auto"
                      ><v-select
                        v-model="secilenKargoFirma"
                        :options="kargoList"
                        @input="externalFilterChanged"
                        placeholder="Kargo seçimi"
                        style="width: 300px"
                        label="name"
                      ></v-select>
                    </b-col>
                    <b-col cols="12" md="auto"
                      ><vs-button
                        @click="kullaniciGorevListesi()"
                        style="border-radius: 5px"
                        class="mb-base mr-3"
                        type="gradient"
                        color="danger"
                        >Listele</vs-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </vx-card>
          </b-col>
        </b-row>
        <b-row>
          <div id="printMe2">
            <vs-card>
              <ag-grid-vue
                style="width: 100%; height: 400px; margin-top: 25px"
                class="ag-theme-alpine"
                :defaultColDef="defaultColDef"
                :suppressCopyRowsToClipboard="true"
                :columnDefs="columnDefsKullanici"
                :rowData="listKullaniciSiparisleri"
                :localeText="localeText"
                @grid-ready="onGridReady"
                @first-data-rendered="onFirstDataRendered"
                :rowSelection="rowSelection"
                :isExternalFilterPresent="isExternalFilterPresent"
                :doesExternalFilterPass="doesExternalFilterPass"
              >
              </ag-grid-vue>
            </vs-card>
          </div>
        </b-row>
      </b-col>
    </b-row>
    <vs-popup
      class="holamundo"
      title="Sipariş Detay"
      :active.sync="popupKartDetay"
    >
      <div id="invoice-page" v-if="plas == '0'">
        <div class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button
              @click="yazdir()"
              class="mb-base mr-3"
              type="border"
              icon-pack="feather"
              icon="icon icon-download"
              >İndir/Yazdır</vs-button
            >
          </div>
        </div>

        <div>
          <vx-card id="invoice-container" style="padding: 25px">
            <!-- INVOICE METADATA -->
            <div id="printMe12">
              <div style="padding: 10%">
                <table style="width: 100%">
                  <tr>
                    <td>
                      <table style="width: 100%" class="border-collapse">
                        <tr>
                          <td style="padding: 10px; text-align: center">
                            <v-barcode
                              v-bind:value="barcodeValue2"
                              font-options="bold"
                              width="4px"
                              height="150px"
                            >
                            </v-barcode>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>

                <hr />
                <table style="width: 100%" class="border-collapse">
                  <tr>
                    <td style="padding: 10px; text-align: center">
                      <h3>Sipariş Notu</h3>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding: 10px; text-align: center">
                      <h4>{{ kullaniciorderNote }}</h4>
                    </td>
                  </tr>
                </table>

                <table
                  style="border-top: 1px solid grey; width: 100%"
                  class="border-collapse"
                >
                  <tr>
                    <td>
                      <table style="width: 100% !important">
                        <tr>
                          <th
                            style="
                              text-align: start;
                              border-bottom: 1px solid grey;
                              padding: 3px;
                            "
                          >
                            <h4>ÜRÜN ADI</h4>
                          </th>

                          <th
                            style="
                              text-align: end;
                              border-bottom: 1px solid grey;
                              padding: 3px;
                            "
                          >
                            <h4>ADET</h4>
                          </th>
                        </tr>

                        <tr
                          :key="indextr"
                          v-for="(tr, indextr) in productDetail"
                        >
                          <td style="padding: 8px; text-align: start">
                            <h4>{{ tr.orderItemName }}</h4>
                          </td>
                          <td style="padding: 8px; text-align: end">
                            <h4>{{ tr.orderItemQuantity }} adet</h4>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <br />
                </table>

                <table style="width: 100%">
                  <tr>
                    <td v-if="kulkargoNo">
                      <table style="width: 100%" class="border-collapse">
                        <tr>
                          <td style="padding: 10px; text-align: center">
                            <v-barcode
                              v-bind:value="kulkargoNo"
                              font-options="bold"
                              width="4px"
                              height="150px"
                            >
                            </v-barcode>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>

                <table>
                  <tr>
                    <td>
                      <h4>{{ kulkargoFirma }} -</h4>
                    </td>
                    <td>
                      <h4>{{ kulkargoIl }} -</h4>
                    </td>
                    <td>
                      <h4>{{ kulkargoIlce }}</h4>
                    </td>
                  </tr>
                </table>
                <table>
                  <tr>
                    <td>
                      <h4>{{ kulAdres }}</h4>
                    </td>
                    <td>
                      <h4>{{ kulShipName }}</h4>
                    </td>
                  </tr>
                </table>
                <table v-if="orderGiftNote">
                  <tr>
                    <td>
                      <h4>Hediye Notu Bilgisi Vardır!</h4>
                    </td>
                  </tr>
                </table>
                <table v-else>
                  <tr>
                    <td>
                      <h6>Hediye Notu Bilgisi Yoktur!</h6>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- INVOICE FOOTER -->
          </vx-card>
        </div>
      </div>
      <div id="invoice-page" v-else>
        <div class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button
              @click="yazdir2()"
              class="mb-base mr-3"
              type="border"
              icon-pack="feather"
              icon="icon icon-download"
              >İndir/Yazdır</vs-button
            >
          </div>
        </div>
        <div>
          <hr />

          <!-- INVOICE METADATA -->
          <table>
            <tr>
              <td style="padding: 10px; text-align: center">
                <vs-input
                  class="inputx"
                  id="barkodF"
                  placeholder="Sipariş Barkodu"
                  @input="kartDetayi()"
                  v-model="siparisBarkoduNumber"
                  :ref="siparisBarkoduNumber"
                />
              </td>
            </tr>
          </table>

          <hr />
          <table
            v-if="siparisBarkodListValidate == true"
            style="border-top: 1px solid grey; width: 550px"
            class="border-collapse"
          >
            <tr>
              <td>
                <table style="width: 550px !important; text-align: center">
                  <tr>
                    <th
                      style="
                        text-align: start;
                        border-bottom: 1px solid grey;
                        padding: 3px;
                      "
                    >
                      <h3>ÜRÜN ADI</h3>
                    </th>
                    <th
                      style="
                        text-align: end;
                        border-bottom: 1px solid grey;
                        padding: 3px;
                      "
                    >
                      <h3>ADET</h3>
                    </th>
                  </tr>
                  <tr :key="indextr" v-for="(tr, indextr) in productDetail">
                    <td style="padding: 8px; text-align: start">
                      <h4>{{ tr.orderItemName }}</h4>
                    </td>
                    <td style="padding: 8px; text-align: end">
                      <h4>{{ tr.orderItemQuantity }} adet</h4>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <br />
          </table>

          <hr />
          <b-row align-h="end">
            <b-col>
              <vs-button
                color="success"
                style="border-radius: 5px; margin: 10px"
                type="gradient"
                icon="edit"
                @click="islemTamamla()"
                >İşlemi Tamamla</vs-button
              >
            </b-col>
          </b-row>
          <vx-card id="invoice-container" v-if="orderGiftNote">
            <div id="printMe123">
              <div style="padding: 50%">
                <table class="border-collapse" style="width: 550px">
                  <tr>
                    <td style="padding: 10px; text-align: center">
                      <h3 style="writing-mode: vertical-rl">
                        {{ orderGiftNote }}
                      </h3>
                    </td>
                  </tr>

                  
                </table>
              </div>
            </div>
          </vx-card>
          <vx-card id="invoice-container" v-else>
            <h6>Hediye Notu Bilgisi Bulunmuyor!</h6>
          </vx-card>
          <hr />

          <!-- INVOICE FOOTER -->
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VueBarcode from "vue-barcode";
import state from "../../store/state";
import Store from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import KullaniciGorevVermeButon from "../components/uzum-components/pazaryeri-components/KullaniciGorevVermeButon.vue";
import vSelect from "vue-select";
import moment from "moment";
export default {
  data() {
    return {
      secilenKargoFirma: "",
      ageType: "everyone",
      kargoList: [],
      optionsKullanicilar: [],
      secilenKullanici: "",
      plas: Store.state.plasiyer,
      siparisBarkoduNumber: "",
      siparisBarkodListValidate: false,
      barcodeValue: "",
      kulkargoNo: "",
      kulkargoFirma: "",
      productDetail: [],
      kullaniciorderNote: "",
      kullaniciorderNumber: "",
      kullaniciorderNumber2: "",
      barcodeValue2: "",
      popupKartDetay: false,
      listKullaniciSiparisleri: [],
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefsKullanici: [],
      localeText: null,
      rowSelection: null,
      genelOrderId: "",
      orderGiftNote: "",
      kulkargoIl: "",
      kulkargoIlce: "",
      kulKullaniciAdi: "",
      kulShipName: "",
      kulAdres: "",
    };
  },
  components: {
    "v-barcode": VueBarcode,
    AgGridVue,
    KullaniciGorevVermeButon,
    "v-select": vSelect,
  },
  methods: {
    externalFilterChanged() {
      this.gridApi.onFilterChanged();
    },
    isExternalFilterPresent() {
      // if ageType is not everyone, then we are filtering
      return this.secilenKargoFirma;
    },
    doesExternalFilterPass(node) {
      console.log(node);

      console.log(this.secilenKargoFirma);
      console.log(node.data.kargoFirma);
      if (this.secilenKargoFirma == "Tümü") {
        return node.data.kargoFirma;
      } else if (node.data.kargoFirma == this.secilenKargoFirma) {
        console.log(node.data.kargoFirma);
        return node.data.kargoFirma;
      }
      /* if (node.data) {
        switch (this.secilenKargoFirma) {
          case "below25":
            return node.data.age < 25;
          case "between25and50":
            return node.data.age >= 25 && node.data.age <= 50;
          case "above50":
            return node.data.age > 50;
          case "dateAfter2008":
            return asDate(node.data.date) > new Date(2008, 1, 1);
          default:
            return true;
        }
      }*/
      //  return true;
    },
    selectionChange() {
      this.siparisBarkoduNumber = "";
      this.productDetail = [];
    },
    islemTamamla() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.secilenKullanici == "") {
        vs.notify({
          title: "Kullanıcı",
          text: "Kullanıcı seçimi yapmadınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        var today = new Date();
        const args3 = {
          token: Store.state.tokenId,
          orderID: vm.genelOrderId,
          durumId: "20",
        };
        soap.createClient(url, function (err, client) {
          client.siparisPaketGuncelleTransferSureci(
            args3,
            function (err, result) {
              if (result.siparisPaketGuncelleTransferSureciResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              vm.veriler = JSON.parse(
                result.siparisPaketGuncelleTransferSureciResult
              );
              if (vm.veriler.response == "Ok") {
                vs.notify({
                  title: "Başarılı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              }
            }
          );
        });
      }
    },
    kullanciListe() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };

      soap.createClient(url, function (err, client) {
        client.kullanciListe(args, function (err, result) {
          if (result.kullanciListeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.kullanciListeResult);
          let list = vm.veriler.jsonData;
          var durumFiltre = [];
          list.forEach((val, index) => {
            if (val.durum == 1 && vm.plas == 0) {
              if (val.rol == 5) {
                durumFiltre.push({
                  name: val.adSoyad,
                  id: val.id,
                  rol: val.rol,
                });
              }
            } else if (val.durum == 1 && vm.plas == 4) {
              if (val.rol == 4) {
                durumFiltre.push({
                  name: val.adSoyad,
                  id: val.id,
                  rol: val.rol,
                });
              }
            }
          });
          vm.optionsKullanicilar = durumFiltre;
        });
      });
    },
    yazdir2() {
      setTimeout(this.yazdirBekle2, 1000);
    },
    yazdirBekle2() {
      this.$htmlToPaper("printMe123");
    },
    yazdir() {
      setTimeout(this.yazdirBekle, 5000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMe12");
    },
    kartDetayi(item) {
      var vs = this.$vs;
      if (this.secilenKullanici == "" && this.plas == "4") {
        vs.notify({
          title: "Kullanıcı",
          text: "Kullanıcı seçimi yapmadınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        this.popupKartDetay = true;

        var vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        if (typeof item != "undefined")
          vm.siparisBarkoduNumber = item.orderNumber;

        if (vm.plas == "4") {
          document.getElementById("barkodF").focus();
        }
        let args = {
          token: Store.state.tokenId,
          orderID: vm.siparisBarkoduNumber,
        };
        if (vm.plas == "0") {
          vm.kullaniciorderNumber = item.orderId;
          vm.barcodeValue = item.orderId;
          vm.kullaniciorderNumber2 = item.orderNumber;
          vm.barcodeValue2 = item.orderNumber;
          vm.kullaniciorderNote = item.siparisNotu;
          vm.kulkargoNo = item.kargoNo;
          vm.kulkargoFirma = item.kargoFirma;
          vm.kulkargoIl = item.il;
          vm.kulkargoIlce = item.ilce;
          vm.kulKullaniciAdi = item.orderCustomer;
          vm.orderGiftNote = item.siparisHediyeNotu;
          vm.kulShipName = item.shipmentName;
          vm.kulAdres = item.adres;

          args = {
            token: Store.state.tokenId,
            orderID: item.orderNumber,
          };
        }
        console.log(args);
        if (args.orderID != "")
          soap.createClient(url, function (err, client) {
            client.siparisDetayTransferSureci(args, function (err, result) {
              if (result.siparisDetayTransferSureciResult == "-1") {
                Store.dispatch("logout");
              }
              vm.veriler = JSON.parse(result.siparisDetayTransferSureciResult);
              vm.productDetail = vm.veriler.jsonData;
              console.log(item);
              console.log(vm.productDetail);

              if (vm.veriler.response == "Ok") {
                vm.genelOrderId = vm.productDetail[0].orderId;
                vm.orderGiftNote = vm.productDetail[0].siparisHediyeNotu;
                vm.kulkargoIl = vm.productDetail[0].il;
                vm.kulkargoIlce = vm.productDetail[0].ilce;
                vm.kulKullaniciAdi = vm.productDetail[0].orderCustomer;
                vm.kulShipName = vm.productDetail[0].shipmentName;
                vm.kulAdres = vm.productDetail[0].adres;

                console.log(vm.productDetail[0].kargoNo);
                vm.kulkargoNo = vm.productDetail[0].kargoNo;
                if (vm.plas != "0") {
                  console.log("innnnnnn");
                  vm.siparisBarkodListValidate = true;
                  var today = new Date();
                  var parsedToday = moment(String(today)).format("YYYYMMDD");
                  const argsdd = {
                    token: Store.state.tokenId,
                    id: "",
                    islem: "1",
                    kullaniciId: vm.secilenKullanici.id,
                    orderNumber: vm.veriler.jsonData[0].orderNumber,
                    role: vm.secilenKullanici.rol,
                    islemKodu: vm.veriler.jsonData[0].orderNumber + parsedToday,
                    pazaryeri: "Ticimax",
                  };
                  soap.createClient(url, function (err, client) {
                    client.kullaniciHareketiEkleGuncelle(
                      argsdd,
                      function (err, result) {
                        if (
                          result.kullaniciHareketiEkleGuncelleResult == "-1"
                        ) {
                          Store.dispatch("logout");
                          //this.$store.dispatch('login', payload)
                        }
                        vm.veriler1 = JSON.parse(
                          result.kullaniciHareketiEkleGuncelleResult
                        );
                        if (vm.veriler1.response == "Ok") {
                          const args2 = {
                            token: Store.state.tokenId,
                            id: vm.veriler1.jsonData.id,
                            islem: "2",
                            kullaniciId: vm.secilenKullanici.id,
                            orderNumber: vm.veriler.jsonData[0].orderNumber,
                            role: vm.secilenKullanici.rol,
                            islemKodu:
                              vm.veriler.jsonData[0].orderNumber + parsedToday,
                            pazaryeri: "Ticimax",
                          };

                          soap.createClient(url, function (err, client) {
                            client.kullaniciHareketiEkleGuncelle(
                              args2,
                              function (err, result) {
                                if (
                                  result.kullaniciHareketiEkleGuncelleResult ==
                                  "-1"
                                ) {
                                  Store.dispatch("logout");
                                  //this.$store.dispatch('login', payload)
                                }
                                vm.veriler2 = JSON.parse(
                                  result.kullaniciHareketiEkleGuncelleResult
                                );
                                if (vm.veriler2.response == "Ok") {
                                  vm.siparisBarkodListValidate = true;
                                  const args3 = {
                                    token: Store.state.tokenId,
                                    orderID: vm.genelOrderId,
                                    durumId: "17",
                                  };
                                  console.log(args3);
                                  soap.createClient(
                                    url,
                                    function (err, client) {
                                      client.siparisPaketGuncelleTransferSureci(
                                        args3,
                                        function (err, result) {
                                          if (
                                            result.siparisPaketGuncelleTransferSureciResult ==
                                            "-1"
                                          ) {
                                            Store.dispatch("logout");
                                            //this.$store.dispatch('login', payload)
                                          }
                                          console.log(result);
                                          vm.veriler3 = JSON.parse(
                                            result.siparisPaketGuncelleTransferSureciResult
                                          );
                                          if (vm.veriler3.response == "Ok") {
                                            vm.siparisBarkoduNumber = "";
                                            vm.kullaniciGorevListesi();
                                            // vm.productDetail = [];
                                            vs.notify({
                                              title: "Başarılı",
                                              text: vm.veriler.message,
                                              iconPack: "feather",
                                              icon: "icon-alert-circle",
                                              color: "success",
                                              position: "top-center",
                                            });
                                          }
                                        }
                                      );
                                    }
                                  );
                                }
                              }
                            );
                          });
                        }
                      }
                    );
                  });
                } else {
                }

                //
              } else if (vm.veriler.error == "Yes") {
                vs.notify({
                  title: "Kullanıcı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            });
          });
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    kullaniciGorevListesi() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        siparisDurum: Store.state.plasiyer,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.siparisTransferSureci(args, function (err, result) {
          if (result.siparisTransferSureciResult == "-1") {
            Store.dispatch("logout");
          }
          console.log(result);
          vm.veriler = JSON.parse(result.siparisTransferSureciResult);
          vm.listKullaniciSiparisleri = vm.veriler.jsonData;
          vm.kargoList = [
            ...new Set(vm.listKullaniciSiparisleri.map((x) => x.kargoFirma)),
          ];
          vm.kargoList.push("Tümü");
          console.log(vm.listKullaniciSiparisleri);
        });
      });
    },
  },
  created() {
    this.rowSelection = "single";
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.kullaniciGorevListesi();
    this.kullanciListe();
  },
  mounted() {
    this.$root.$on("setkartDetayiKullanici", (item) => {
      // your code goes here
      this.kartDetayi(item);
    });
    this.$root.$on("setkullaniciGorevListesi", () => {
      // your code goes here
      this.kullaniciGorevListesi();
    });
  },
  beforeDestroy() {
    this.$root.$off("setkartDetayiKullanici");
    this.$root.$off("setkullaniciGorevListesi");
  },
  beforeMount() {
    this.columnDefsKullanici = [
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Ad Soyad",
        field: "orderCustomer",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kargo Firma",
        field: "kargoFirma",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Kargo Numarası",
        field: "kargoNo",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Sipariş Notu",
        field: "siparisNotu",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        width: 200,
        field: "",
        cellRendererFramework: "KullaniciGorevVermeButon",
        autoHeight: true,
      },
    ];
  },
};
</script>
